import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Input } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { SAVE_USER } from "pages/manage/graphql";
import { useEffect, useRef, useState } from "react";

const AccountForm = ({ initialEmail, onCreated }) => {
  const ref = useRef();
  const [email, setEmail] = useState(initialEmail || "");

  const [save, saveRes] = useMutation(SAVE_USER, {
    variables: {
      userInput: { email },
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    onCompleted(res) {
      onCreated(res.saveUser.user);
    },
  });

  useEffect(() => {
    setTimeout(() => {
      ref.current?.focus();
    }, 100);
  }, []);

  function submitHandler(e) {
    e.preventDefault();
    if (saveRes.loading) return;
    save();
  }

  return (
    <form submit={submitHandler}>
      <div className="flex space-x-3 items-center">
        <label htmlFor="">Email: </label>
        <Input
          ref={ref}
          className="w-full"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div>
        <p className="text-sm text-gray-600 mt-2 mb-4">
          Just input an email address to create a new account for Business
          Portal.
          <br />
          You don't need to set a password — on our business website, users can
          log in by requesting a login code with their email.
        </p>
      </div>

      <hr />

      <div>
        <Button primary onClick={save} loading={saveRes.loading}>
          Create
        </Button>
      </div>
    </form>
  );
};

export default AccountForm;
